export default __webpack_public_path__ + "static/media/clem-onojegaw.fb996a07.jpg";